import { useEffect, useState } from "react";
import { LiaPlaneDepartureSolid } from "react-icons/lia";

const driveAnimation = `
  @keyframes driveX {
    0% { transform: translateX(0); }
    50% { transform: translateX(12px); }
    100% { transform: translateX(0); }
  }
`;

const DeliveryDateBadge = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  useEffect(() => {
    const addDays = (date, days) => {
      const d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    };

    const moveToNextMondayIfWeekend = (date) => {
      const d = new Date(date);
      const day = d.getDay(); 

      if (day === 6) return addDays(d, 2); 
      if (day === 0) return addDays(d, 1); 
      return d;
    };

    // const getOrdinalSuffix = (n) => {
    //   if (n > 3 && n < 21) return "th";
    //   switch (n % 10) {
    //     case 1:
    //       return "st";
    //     case 2:
    //       return "nd";
    //     case 3:
    //       return "rd";
    //     default:
    //       return "th";
    //   }
    // };
    
    const formatDisplayDate = (date) => {
      const monthsShort = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

      const dayNumber = date.getDate();
      const month = monthsShort[date.getMonth()];
      const year = date.getFullYear();

      return `${dayNumber} ${month} ${year}`;
    };

    // OLD LOGIC - Commented out due to China holiday (one month)
    // Will be enabled later
    // // today + 12 days, then adjust weekends
    // let fd = addDays(new Date(), 12);
    // fd = moveToNextMondayIfWeekend(fd);

    // // toDate = fromDate + 6 days, adjust weekends
    // let td = addDays(fd, 6);
    // td = moveToNextMondayIfWeekend(td);

    // NEW LOGIC - Minimum date set to 1 March 2026 due to China holiday
    const minDate = new Date(2026, 2, 1); // March 1, 2026 (month is 0-indexed, so 2 = March)
    
    // 7-10 day delivery window
    let fd = addDays(new Date(), 14);
    fd = moveToNextMondayIfWeekend(fd);
    
    // Ensure fromDate is at least 1 March 2026
    if (fd < minDate) {
      fd = new Date(minDate);
      fd = moveToNextMondayIfWeekend(fd);
    }

    // toDate = fromDate + 3 days to keep 7-10 range
    let td = addDays(fd, 3);
    td = moveToNextMondayIfWeekend(td);

    setFromDate(formatDisplayDate(fd));
    setToDate(formatDisplayDate(td));
  }, []);

  return (
    <>
      {/* local animation styles */}
      <style>{driveAnimation}</style>

      <p className="relative flex items-center gap-2 pl-10 px-2 py-3 mb-0 mt-3 text-xs sm:text-sm md:text-[0.9rem] bg-white rounded-lg shadow-sm border border-gray-100" style={{lineHeight:'1'}}>
        <LiaPlaneDepartureSolid
          className="absolute left-3 top-2/2 h-6 w-6 -translate-y-1/2 text-emerald-700"
          style={{ animation: "driveX 1.8s ease-in-out infinite" }}
        />

        <span className="text-xs sm:text-sm md:text-[0.9rem]" style={{paddingLeft:'2.8rem'}}>Get it between </span>
        <strong className="text-emerald-700 text-xs sm:text-sm md:text-[0.9rem]">
          <span>{fromDate}</span> - <span>{toDate}</span>
        </strong>
      </p>
    </>
  );
};

export default DeliveryDateBadge;
